import React from 'react';
import PropTypes from 'prop-types';
import RequiredInput from '../elements/required-input';

const LastNameInput = ({
  model, label, controlId, readOnly, errorLabel
}) => (
  <RequiredInput
    controlId={controlId}
    errorLabel={errorLabel}
    label={label}
    model={model}
    placeholder="Last name"
    readOnly={readOnly}
  />
);

LastNameInput.propTypes = {
  model: PropTypes.string,
  label: PropTypes.string,
  readOnly: PropTypes.bool,
  controlId: PropTypes.string,
  errorLabel: PropTypes.string,
};

LastNameInput.defaultProps = {
  model: '.last_name',
  label: 'Last name',
  readOnly: false,
  controlId: 'lastName',
  errorLabel: 'user_last_name'
};

export default LastNameInput;



// WEBPACK FOOTER //
// ./src/components/common/form/user/user-last-name-input.jsx